<nav>
  <div class="nav-wrapper teal">
    <a href='#' class="brand-logo center">National Pokedex</a>
  </div>
</nav>

<router-outlet></router-outlet>
